import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import Axios from 'axios';
import { needLogin, doLogin } from '@tencent/wdocs-request';
import i18next from 'i18next';
import { ID_PREFIX_REGEX, isVid, isAppId, isWedriveUid, isWedriveUin, isXid, isWxTinyid, isOpenId, sleep } from '@tencent/wdocs-utils';
import ua from '@tencent/docs-user-agent';

var version = "1.2.67";

var UserType;

(function (UserType) {
  UserType[UserType["kUnkown"] = 0] = "kUnkown";
  UserType[UserType["kSameCorp"] = 1] = "kSameCorp";
  UserType[UserType["kExtCorp"] = 2] = "kExtCorp";
  UserType[UserType["kWechat"] = 3] = "kWechat";
  UserType[UserType["kOther"] = 4] = "kOther";
})(UserType || (UserType = {}));

var UserLoginType;

(function (UserLoginType) {
  UserLoginType[UserLoginType["kUnkown"] = 0] = "kUnkown";
  UserLoginType[UserLoginType["kQqMail"] = 1] = "kQqMail";
  UserLoginType[UserLoginType["kQyMail"] = 2] = "kQyMail";
  UserLoginType[UserLoginType["kWeWork"] = 3] = "kWeWork";
  UserLoginType[UserLoginType["kWeChat"] = 4] = "kWeChat";
})(UserLoginType || (UserLoginType = {}));

var DisplayNamePriorityType;

(function (DisplayNamePriorityType) {
  DisplayNamePriorityType[DisplayNamePriorityType["UserName"] = 1] = "UserName";
  DisplayNamePriorityType[DisplayNamePriorityType["UserAlias"] = 2] = "UserAlias";
})(DisplayNamePriorityType || (DisplayNamePriorityType = {}));

var _globalThis$2 = function (Object) {
  function get() {
    var _global = this || self;

    delete Object.prototype.__magic__;
    return _global;
  }

  if (typeof globalThis === "object") {
    return globalThis;
  }

  if (this) {
    return get();
  } else {
    Object.defineProperty(Object.prototype, "__magic__", {
      configurable: true,
      get: get
    });
    var _global = __magic__;
    return _global;
  }
}(Object);
var enterpriseDomain = '.weixin.qq.com';
/**
 * 从传入的 url 或者 location 中, 获取单个指定 key 的 查询结果;
 * 返回 '' 空字符或者对应的值.
 * @param key
 * @param url
 */

function getURLQuery(key) {
  var _globalThis$location$, _globalThis$location;

  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (_globalThis$location$ = (_globalThis$location = _globalThis$2.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.href) !== null && _globalThis$location$ !== void 0 ? _globalThis$location$ : '';
  var querystring = url.replace(/.*\?/, '');
  var m = null;

  if (querystring) {
    m = querystring.match(new RegExp("(\\?|&)".concat(key, "=([^&]*)(&|$)")));
  }

  return !m ? '' : decodeURIComponent(m[2].replace(/%/g, '%25'));
}
/**
 * 根据 key 从 cookie 中获取对应的信息
 * @param key
 */

function getCookie(key) {
  var _globalThis$document;

  var r = new RegExp("(?:^|;+|\\s+)".concat(key, "=([^;]*)"));

  if ((_globalThis$document = _globalThis$2.document) !== null && _globalThis$document !== void 0 && _globalThis$document.cookie) {
    var m = _globalThis$2.document.cookie.match(r);

    if (m) return decodeURIComponent(m[1]);
  }

  return '';
}
/**
 * 获取顺序：
 *  1. clientVars.padId
 *  2.
 */

function getPadId() {
  var _globalThis$basicClie, _globalThis$basicClie2, _globalThis$basicClie3, _globalThis$clientVar, _globalThis$location2, _globalThis$location3, _globalThis$document2;

  if ((_globalThis$basicClie = _globalThis$2.basicClientVars) !== null && _globalThis$basicClie !== void 0 && (_globalThis$basicClie2 = _globalThis$basicClie.docInfo) !== null && _globalThis$basicClie2 !== void 0 && (_globalThis$basicClie3 = _globalThis$basicClie2.padInfo) !== null && _globalThis$basicClie3 !== void 0 && _globalThis$basicClie3.padId) {
    var _globalThis$basicClie4, _globalThis$basicClie5, _globalThis$basicClie6;

    return correctFormDocId((_globalThis$basicClie4 = _globalThis$2.basicClientVars) === null || _globalThis$basicClie4 === void 0 ? void 0 : (_globalThis$basicClie5 = _globalThis$basicClie4.docInfo) === null || _globalThis$basicClie5 === void 0 ? void 0 : (_globalThis$basicClie6 = _globalThis$basicClie5.padInfo) === null || _globalThis$basicClie6 === void 0 ? void 0 : _globalThis$basicClie6.padId);
  }

  if ((_globalThis$clientVar = _globalThis$2.clientVars) !== null && _globalThis$clientVar !== void 0 && _globalThis$clientVar.padId) {
    var _globalThis$clientVar2;

    return correctFormDocId((_globalThis$clientVar2 = _globalThis$2.clientVars) === null || _globalThis$clientVar2 === void 0 ? void 0 : _globalThis$clientVar2.padId);
  }

  var docidInQuery = getURLQuery('docid');
  if (docidInQuery) return correctFormDocId(docidInQuery);
  var docidInPath = ((_globalThis$location2 = _globalThis$2.location) === null || _globalThis$location2 === void 0 ? void 0 : (_globalThis$location3 = _globalThis$location2.pathname) === null || _globalThis$location3 === void 0 ? void 0 : _globalThis$location3.split('/').pop()) || '';
  if (/^[a-z]\d_/.test(docidInPath)) return correctFormDocId(docidInPath);
  var referer = (_globalThis$document2 = _globalThis$2.document) === null || _globalThis$document2 === void 0 ? void 0 : _globalThis$document2.referrer;

  if (referer) {
    var docidInReferer = getURLQuery('docid', referer);
    if (docidInReferer) return correctFormDocId(docidInReferer, referer);
    var pathnameInReferer = referer.replace(/\?.*/, '');
    var docidInRefererPath = pathnameInReferer.split('/').pop() || '';
    if (/^[a-z]\d_/.test(docidInRefererPath)) return correctFormDocId(docidInRefererPath, referer);
  }

  return '';
}
/**
 * 收集表的 docid 要补上 c2_ 开头
 */

function correctFormDocId(docid) {
  var _globalThis$location$2, _globalThis$location4;

  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (_globalThis$location$2 = (_globalThis$location4 = _globalThis$2.location) === null || _globalThis$location4 === void 0 ? void 0 : _globalThis$location4.href) !== null && _globalThis$location$2 !== void 0 ? _globalThis$location$2 : '';

  try {
    var urlObject = new URL(url);

    if (urlObject.pathname.match(/^\/forms\//i) && docid && docid !== '0' && !docid.match(/^[a-z]\d_/i)) {
      return "c2_".concat(docid);
    }
  } catch (err) {
    console.error(err);
  }

  return docid;
}
/**
 * getXsrf
 */

function getXsrf() {
  return getCookie('TOK') || '';
}
/**
 * simple qs stringify
 */

function qsStringify(obj) {
  var query = [];
  Object.keys(obj).forEach(function (key) {
    var value = obj[key];

    if (Array.isArray(value)) {
      value.forEach(function (item) {
        return query.push("".concat(key, "=").concat(encodeURIComponent(item)));
      });
    } else {
      query.push("".concat(key, "=").concat(encodeURIComponent(value)));
    }
  });
  return query.join('&');
}
function retryableAxios() {
  var ins = Axios.create({
    // @ts-ignore
    retry: 0
  });
  ins.interceptors.request.use(function (config) {
    config.requestStart = Date.now();
    return config;
  });
  ins.interceptors.response.use( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
      var _res$data$head$ret, _res$data, _res$data$head, _res$data2, _globalThis$tencentDo, _globalThis$tencentDo2;

      var config, retcode;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              config = res.config;
              retcode = (_res$data$head$ret = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$head = _res$data.head) === null || _res$data$head === void 0 ? void 0 : _res$data$head.ret) !== null && _res$data$head$ret !== void 0 ? _res$data$head$ret : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.retcode;
              (_globalThis$tencentDo = _globalThis$2.tencentDocReport) === null || _globalThis$tencentDo === void 0 ? void 0 : (_globalThis$tencentDo2 = _globalThis$tencentDo.retcodeEnt) === null || _globalThis$tencentDo2 === void 0 ? void 0 : _globalThis$tencentDo2.call(_globalThis$tencentDo, {
                code: retcode,
                url: config.url || '',
                time: config.requestStart ? Date.now() - config.requestStart : 0,
                statusCode: res.status || 0
              });

              if (!needLogin(retcode)) {
                _context.next = 7;
                break;
              }

              _context.next = 6;
              return doLogin(res, ins);

            case 6:
              return _context.abrupt("return", _context.sent);

            case 7:
              if (!(retcode !== 0)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", Promise.reject(res));

            case 9:
              return _context.abrupt("return", res);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), function (err) {
    if (err.config) {
      err.config.retry = (err.config.retry || 0) + 1;

      if (err.config.retry < 2) {
        return Axios.request(err.config);
      }
    }

    return Promise.reject(err);
  });
  return ins;
}
function isServerSideRender() {
  return typeof window === 'undefined';
}
function resolveWhenCatch() {
  return Promise.resolve();
}
var isInEnterpriseDomain = function isInEnterpriseDomain() {
  return location.host.endsWith(enterpriseDomain);
};

var _ref;
var i18nOfHost = (_ref = typeof window === 'undefined' ? null : window.i18n) !== null && _ref !== void 0 ? _ref : i18next;
function initI18n(resources, namespace) {
  var init = function init(options) {
    if (!i18nOfHost || !i18nOfHost.getResource || !i18nOfHost.addResource) return;
    Object.entries(resources).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          lng = _ref3[0],
          resource = _ref3[1];

      Object.entries(resource).forEach(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            key = _ref5[0],
            value = _ref5[1];

        var ns = namespace !== null && namespace !== void 0 ? namespace : options.defaultNS || 'legacy';

        if (!i18nOfHost.getResource(lng, ns, key)) {
          i18nOfHost.addResource(lng, ns, key, value);
        }
      });
    });
  }; // Serverside rendering


  if (!i18nOfHost || typeof window === 'undefined') return; // 品类宿主表示：我们没有用 i18next，组件自己单干吧

  var noSharedI18next = !!window.noSharedI18next; // 即使品类没有提供，也考虑别的组件提供了

  if (noSharedI18next && !window.i18n) {
    // 后面的 wdc 组件复用这个实例
    window.i18n = i18next;
    var lng = 'zh-CN'; // 取其他品类共享的 language

    try {
      var shareLng = localStorage.getItem('shared-language');
      if (shareLng) lng = shareLng;
    } catch (e) {}

    i18next.init({
      lng: lng,
      resources: {},
      debug: true,
      ns: 'legacy',
      defaultNS: 'legacy'
    }); // fall through
  }

  i18nOfHost.isInitialized ? // 如果 i18next 已经初始化了，直接复用品类的
  init(i18nOfHost.options) : // 如果没有的话，也要等待品类初始化，我们组件不要自己初始化
  // 如果品类后初始化，且品类和组件一起打包，i18next是同个实例，品类初始化时就会覆盖组件了
  i18nOfHost.on('initialized', init);
}
function $t(key, options) {
  var result = i18nOfHost === null || i18nOfHost === void 0 ? void 0 : i18nOfHost.t(key, options); // 没有正确翻译时直接返回 key

  if (!result) {
    return "".concat(key);
  }

  return result;
}

var resources = {
  'zh-CN': {
    微信: '微信',
    自动化流程: '自动化流程'
  },
  'zh-HK': {
    微信: '微信',
    自动化流程: '自動化流程'
  },
  'en-US': {
    微信: 'WeChat',
    自动化流程: 'Automated Process'
  }
};
initI18n(resources);

var _globalThis$1 = function (Object) {
  function get() {
    var _global = this || self;

    delete Object.prototype.__magic__;
    return _global;
  }

  if (typeof globalThis === "object") {
    return globalThis;
  }

  if (this) {
    return get();
  } else {
    Object.defineProperty(Object.prototype, "__magic__", {
      configurable: true,
      get: get
    });
    var _global = __magic__;
    return _global;
  }
}(Object);

/**
 * 上报拉取后台接口失败的 id
 */
var UnknownIdReporter = /*#__PURE__*/function () {
  function UnknownIdReporter() {
    _classCallCheck(this, UnknownIdReporter);

    _defineProperty(this, "throttleDuration", 10000);

    _defineProperty(this, "unknownIdSet", void 0);

    _defineProperty(this, "timer", null);

    this.unknownIdSet = new Set();
  }

  _createClass(UnknownIdReporter, [{
    key: "add",
    value: function add(id) {
      this.unknownIdSet.add(id);
      this.throttleReport();
    }
  }, {
    key: "throttleReport",
    value: function throttleReport() {
      var _this = this;

      if (!this.timer) {
        this.timer = setTimeout(function () {
          _this.timer = null;

          _this.report();
        }, this.throttleDuration);
      }
    }
  }, {
    key: "report",
    value: function report() {
      var _window$tencentDocRep, _window$tencentDocRep2;

      if (this.unknownIdSet.size === 0) return;

      if (typeof ((_window$tencentDocRep = window.tencentDocReport) === null || _window$tencentDocRep === void 0 ? void 0 : (_window$tencentDocRep2 = _window$tencentDocRep.cube) === null || _window$tencentDocRep2 === void 0 ? void 0 : _window$tencentDocRep2.wdocs) !== 'function') {
        this.errLog('report cube not ready');
        return;
      }

      this.errLog('report unknown id', this.unknownIdSet);
      window.tencentDocReport.cube.wdocs({
        module: 'userCenter',
        action: 'fail',
        opername: 'reportUnknownId',
        str1: Array.from(this.unknownIdSet).join(',')
      });
      this.unknownIdSet.clear();
    }
  }, {
    key: "errLog",
    value: function errLog() {
      var _globalThis$log;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      // @ts-ignore
      (_globalThis$log = _globalThis$1.log) === null || _globalThis$log === void 0 ? void 0 : _globalThis$log.error.apply(_globalThis$log, ['[@tencent/wdocs-user-center]'].concat(args));
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!this.instance) {
        this.instance = new UnknownIdReporter();
      }

      return this.instance;
    }
  }]);

  return UnknownIdReporter;
}();

_defineProperty(UnknownIdReporter, "instance", void 0);

var _globalThis = function (Object) {
  function get() {
    var _global = this || self;

    delete Object.prototype.__magic__;
    return _global;
  }

  if (typeof globalThis === "object") {
    return globalThis;
  }

  if (this) {
    return get();
  } else {
    Object.defineProperty(Object.prototype, "__magic__", {
      configurable: true,
      get: get
    });
    var _global = __magic__;
    return _global;
  }
}(Object);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var WECHAT_CORP_ID = '0'; // export enum MemberInfoScene {
//   kMemberInfoSceneUnknown = 1,
//   kMemberInfoDocDefault = 100,  // 文档默认 检查企业内
//   kMemberInfoDocMemberList = 101,  // 文档成员列表 检查是否文档成员
//   kMemberInfoDocAt = 102,  // at人  检查关系链
//   kMemberInfoDocAddMember = 103,  // 加人 检查关系链
//   kMemberInfoDocJoin = 104, // 用户进入文档房间
//   kMemberInfoFormDefault = 500,  // 收集表检查企业内
// };
// 这个字段只是表示为了什么功能调接口，经常加枚举
// 这里写成number避免每家一个枚举都要改包，品类自己写枚举好了

var WdocsUserCenter = /*#__PURE__*/function () {
  // TODO(stee): 打开60s后允许合并一小段时间内的所有请求
  // private quickMerge = false;
  // 正在查询中（请求中）的 id, 用这种方式避免同一个 id 被多次请求

  /**
   * 如何判断是openId登录态还是vid登录态？
   * 1. cookie中存在`tdoc_uid`和`wedoc_openid`，则为openId登录态
   * 2. cookie中存在`wedrive_uin`或者`tdoc_vid`，则为vid登录态
   */

  /**
   * TODO: @steephenliu 限制map个数，除了本人，其他人保留前1k个为宜
   */
  function WdocsUserCenter() {
    _classCallCheck(this, WdocsUserCenter);

    _defineProperty(this, "version", version);

    _defineProperty(this, "benchQueryLimit", 250);

    _defineProperty(this, "batchQueryDepartLimit", 100);

    _defineProperty(this, "keepFailureUntil", 120000);

    _defineProperty(this, "currentDocId", void 0);

    _defineProperty(this, "queryingIdPromise", new Map());

    _defineProperty(this, "userInfo", void 0);

    _defineProperty(this, "userInfoReqPromise", void 0);

    _defineProperty(this, "isOpenIdSessionFlag", void 0);

    _defineProperty(this, "map", new Map());

    _defineProperty(this, "departmentMap", new Map());

    _defineProperty(this, "tagMap", new Map());

    _defineProperty(this, "remarkMap", new Map());

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "displayNamePriorityType", DisplayNamePriorityType.UserAlias);

    this.isOpenIdSessionFlag = !!getCookie('tdoc_uid') && !!getCookie('wedoc_openid');
    this.axios = retryableAxios();

    if (isServerSideRender() || !isInEnterpriseDomain()) {
      this.getGuestUserInfo();
    }

    this.setBuildInInfos(); // setTimeout(() => {
    //   this.quickMerge = true;
    // }, 60000);
  }
  /**
   * 特殊情况调用，需要传入docid
   * @param docId
   */


  _createClass(WdocsUserCenter, [{
    key: "setDocId",
    value: function setDocId(docId) {
      this.currentDocId = docId;
    }
    /**
     * 通过id获取用户信息
     * @param id 可以使用vid, uid, openid, tinyid
     * @returns
     */

  }, {
    key: "queryByAnyId",
    value: function () {
      var _queryByAnyId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id, extraQueryMap, scene) {
        var map;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.queryUserInfoMap([id], extraQueryMap, scene);

              case 2:
                map = _context.sent;
                return _context.abrupt("return", map.get(id));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function queryByAnyId(_x, _x2, _x3) {
        return _queryByAnyId.apply(this, arguments);
      }

      return queryByAnyId;
    }()
    /**
     * 判断两个id是否为同一个用户
     * @param ida
     * @param idb
     * @returns
     */

  }, {
    key: "isEqualAsync",
    value: function () {
      var _isEqualAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ida, idb) {
        var queryIdA, queryIdB, result, a, b;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                queryIdA = "".concat(ida).replace(ID_PREFIX_REGEX, '');
                queryIdB = "".concat(idb).replace(ID_PREFIX_REGEX, '');

                if (!(queryIdA === queryIdB)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", true);

              case 4:
                _context2.next = 6;
                return this.queryUserInfoMap([queryIdA, queryIdB]);

              case 6:
                result = _context2.sent;
                a = result.get(queryIdA);
                b = result.get(queryIdB);
                return _context2.abrupt("return", a === b);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function isEqualAsync(_x4, _x5) {
        return _isEqualAsync.apply(this, arguments);
      }

      return isEqualAsync;
    }()
    /**
     * 判断两个id是否为同一个用户
     * Notice: 需要预先通过`queryUserInfoMap`缓存用户信息
     * @param ida
     * @param idb
     */

  }, {
    key: "isEqual",
    value: function isEqual(ida, idb) {
      if (ida === idb) return true;
      if (!ida || !idb) return false;
      ida = "".concat(ida).replace(ID_PREFIX_REGEX, '');
      idb = "".concat(idb).replace(ID_PREFIX_REGEX, '');
      var userA = this.map.get(ida);
      var userB = this.map.get(idb);
      if (userA && userA === userB) return true;

      if (userA) {
        if (userA.uid === idb || userA.vid === idb || userA.openid === idb || userA.tinyid === idb || userA.xid === idb) {
          return true;
        }
      } else if (!this.queryingIdPromise.has(ida)) ;

      if (userB) {
        if (userB.uid === ida || userB.vid === ida || userB.openid === ida || userB.tinyid === ida || userB.xid === ida) {
          return true;
        }
      } else if (!this.queryingIdPromise.has(idb)) ; // if (notExists.length > 0) this.queryUserInfo(notExists);


      return false;
    }
    /**
     * 批量查询标签信息（有缓存）
     * @param ids 标签ID
     */

  }, {
    key: "queryTagInfos",
    value: function () {
      var _queryTagInfos = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(ids) {
        var _this = this;

        var notExists, currentQuery, params;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.userInfoReqPromise) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 3;
                return this.userInfoReqPromise["catch"](resolveWhenCatch);

              case 3:
                _context3.next = 7;
                break;

              case 5:
                _context3.next = 7;
                return this.getUserInfo()["catch"](resolveWhenCatch);

              case 7:
                notExists = ids.filter(function (id) {
                  return !_this.tagMap.has("".concat(id));
                });

              case 8:
                if (!notExists.length) {
                  _context3.next = 15;
                  break;
                }

                currentQuery = notExists.splice(0, this.benchQueryLimit);
                params = {
                  func: 1,
                  tag_ids: currentQuery
                };
                _context3.next = 13;
                return this.axios.get("/diskaddr/tag?".concat(qsStringify(params))).then(function (res) {
                  var _res$data, _res$data$head, _res$data2, _res$data2$body;

                  if (((_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$head = _res$data.head) === null || _res$data$head === void 0 ? void 0 : _res$data$head.ret) !== 0) return;
                  var tagInfos = ((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$body = _res$data2.body) === null || _res$data2$body === void 0 ? void 0 : _res$data2$body.tag_infos) || [];
                  tagInfos.forEach(function (i) {
                    return _this.tagMap.set("".concat(i.tag_id), i);
                  });
                })["catch"](function (e) {
                  _this.errLog('queryTagInfos catch an error, ', ids.join(','), e);

                  return Promise.resolve();
                });

              case 13:
                _context3.next = 8;
                break;

              case 15:
                return _context3.abrupt("return", ids.map(function (id) {
                  var tag = _this.tagMap.get("".concat(id));

                  if (tag) return {
                    tag_id: "".concat(tag.tag_id),
                    tag_name: tag.tag_name
                  };
                  UnknownIdReporter.getInstance().add("".concat(id));
                  return {
                    tag_id: "".concat(id),
                    tag_name: 'unknown'
                  };
                }));

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function queryTagInfos(_x6) {
        return _queryTagInfos.apply(this, arguments);
      }

      return queryTagInfos;
    }()
    /**
     * 批量查询标签信息（有缓存）
     * @param ids 标签ID
     */

  }, {
    key: "queryTagInfoMap",
    value: function () {
      var _queryTagInfoMap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(ids) {
        var tagInfos, map;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.queryTagInfos(ids);

              case 2:
                tagInfos = _context4.sent;
                map = new Map();
                tagInfos.forEach(function (i) {
                  return map.set(i.tag_id, i);
                });
                return _context4.abrupt("return", map);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function queryTagInfoMap(_x7) {
        return _queryTagInfoMap.apply(this, arguments);
      }

      return queryTagInfoMap;
    }()
    /**
     * 批量查询用户信息
     * @deprecated use `queryUserInfoMap` instead
     * @param ids
     * @returns Map<string, WedriveUserInfo>
     */

  }, {
    key: "queryUserInfoByAnyIds",
    value: function () {
      var _queryUserInfoByAnyIds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(ids, extraQueryMap, scene) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.queryUserInfoMap(ids, extraQueryMap, scene);

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function queryUserInfoByAnyIds(_x8, _x9, _x10) {
        return _queryUserInfoByAnyIds.apply(this, arguments);
      }

      return queryUserInfoByAnyIds;
    }()
    /**
     * 批量查询用户信息
     * @param ids
     * @returns Map<string, WedriveUserInfo>
     */

  }, {
    key: "queryUserInfoMap",
    value: function () {
      var _queryUserInfoMap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(ids, extraQueryMap, scene, sceneId // 日程&会议场景
      ) {
        var _this2 = this;

        var queryingIds, idList, tinyidList, tinyIdReq, uidReq, promise;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(!ids || !ids.length)) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return", new Map());

              case 2:
                if (!this.userInfoReqPromise) {
                  _context6.next = 7;
                  break;
                }

                _context6.next = 5;
                return this.userInfoReqPromise["catch"](resolveWhenCatch);

              case 5:
                _context6.next = 9;
                break;

              case 7:
                _context6.next = 9;
                return this.getUserInfo()["catch"](resolveWhenCatch);

              case 9:
                queryingIds = [];
                idList = [];
                tinyidList = [];
                new Set(ids).forEach(function (id) {
                  var _extraQueryMap$queryI;

                  var queryId = "".concat(id).trim().replace(ID_PREFIX_REGEX, '');
                  if (!queryId) return;
                  if (queryId === '0') return;
                  if (_this2.map.has(queryId)) return;

                  if (_this2.queryingIdPromise.has(queryId)) {
                    queryingIds.push(_this2.queryingIdPromise.get(queryId));
                    return;
                  }

                  var commonParams = {
                    is_external_member: extraQueryMap === null || extraQueryMap === void 0 ? void 0 : (_extraQueryMap$queryI = extraQueryMap[queryId]) === null || _extraQueryMap$queryI === void 0 ? void 0 : _extraQueryMap$queryI.isExternalMember
                  };
                  if (_this2.isWxTinyid(queryId)) tinyidList.push(queryId);else if (_this2.isVid(queryId)) idList.push(_objectSpread({
                    vid: queryId
                  }, commonParams));else if (_this2.isAppId(queryId)) idList.push(_objectSpread({
                    vid: queryId
                  }, commonParams));else if (_this2.isWedriveUin(queryId)) idList.push(_objectSpread({
                    vid: queryId
                  }, commonParams));else if (_this2.isOpenId(queryId)) idList.push(_objectSpread({
                    openid: queryId
                  }, commonParams));else if (_this2.isXid(queryId)) idList.push(_objectSpread({
                    xid: queryId
                  }, commonParams));else idList.push(_objectSpread({
                    uid: queryId
                  }, commonParams));
                });
                tinyIdReq = Promise.resolve();

                if (tinyidList.length) {
                  tinyIdReq = this.queryUserInfoByTinyid(tinyidList, extraQueryMap, scene).then(function (res) {
                    res.forEach(function (user) {
                      if (user.vid) _this2.map.set(user.vid, user);
                      if (user.uid) _this2.map.set(user.uid, user);
                      if (user.openid) _this2.map.set(user.openid, user);
                      if (user.tinyid) _this2.map.set(user.tinyid, user);
                      if (user.xid) _this2.map.set(user.xid, user);
                    });
                  })["catch"](function (e) {
                    _this2.errLog('queryUserInfoMap error', e);

                    return Promise.resolve();
                  });
                }

                uidReq = Promise.resolve();

                if (idList.length) {
                  uidReq = this.queryUserInfoInWedrive(idList, scene, sceneId).then(function (res) {
                    return _this2.fillUserRemark(res);
                  }).then(function (res) {
                    res.forEach(function (user) {
                      if (user.vid) _this2.map.set(user.vid, user);
                      if (user.uid) _this2.map.set(user.uid, user);
                      if (user.openid) _this2.map.set(user.openid, user);
                      if (user.xid) _this2.map.set(user.xid, user);
                    });
                  })["catch"](function (e) {
                    _this2.errLog('queryUserInfoMap error', e);

                    return Promise.resolve();
                  });
                }

                promise = Promise.all([tinyIdReq, uidReq].concat(queryingIds)); // 如果有正在查询中的 id，则将请求放到队列中防止重复请求

                ids.filter(function (id) {
                  return !_this2.queryingIdPromise.has(id);
                }).forEach(function (id) {
                  return _this2.queryingIdPromise.set("".concat(id).replace(ID_PREFIX_REGEX, ''), promise);
                });
                _context6.next = 21;
                return promise;

              case 21:
                // 保持一段时间的promise，避免失败以后反复请求
                setTimeout(function () {
                  _this2.queryingIdPromise.forEach(function (v, id) {
                    if (promise === v) _this2.queryingIdPromise["delete"](id);
                  });
                }, this.keepFailureUntil);
                return _context6.abrupt("return", ids.reduce(function (map, id) {
                  var queryId = "".concat(id).replace(ID_PREFIX_REGEX, '');

                  if (_this2.map.has(queryId)) {
                    _this2.queryingIdPromise["delete"](queryId);

                    map.set(id, _this2.map.get(queryId));
                  } else {
                    UnknownIdReporter.getInstance().add(queryId);
                    map.set(id, {
                      has_error: true,
                      uid: queryId,
                      vid: queryId,
                      openid: _this2.isOpenId(queryId) ? queryId : '',
                      xid: _this2.isXid(queryId) ? queryId : '',
                      name: 'unknown',
                      user_type: 0,
                      position: '',
                      english_name: '',
                      avatar: '',
                      corp_name: '',
                      corp_id: '',
                      type: 1
                    });
                  }

                  return map;
                }, new Map()));

              case 23:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function queryUserInfoMap(_x11, _x12, _x13, _x14) {
        return _queryUserInfoMap.apply(this, arguments);
      }

      return queryUserInfoMap;
    }()
    /**
     * @param ids vid, uid, openid, tinyid
     * @returns Array<WedriveUserInfo> 用户信息数组
     */

  }, {
    key: "queryUserInfo",
    value: function () {
      var _queryUserInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(ids, extraQueryMap, scene, sceneId) {
        var map;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.queryUserInfoMap(ids, extraQueryMap, scene, sceneId);

              case 2:
                map = _context7.sent;
                return _context7.abrupt("return", Array.from(map.values()));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function queryUserInfo(_x15, _x16, _x17, _x18) {
        return _queryUserInfo.apply(this, arguments);
      }

      return queryUserInfo;
    }()
    /**
     * 查询组织信息
     * @param ids departId
     * @returns
     */

  }, {
    key: "queryDepartInfo",
    value: function () {
      var _queryDepartInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(ids) {
        var departmentMap;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.queryDepartInfoMap(ids);

              case 2:
                departmentMap = _context8.sent;
                return _context8.abrupt("return", Array.from(departmentMap.values()));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function queryDepartInfo(_x19) {
        return _queryDepartInfo.apply(this, arguments);
      }

      return queryDepartInfo;
    }()
    /**
     * 查询组织信息
     * @param ids departId
     * @returns
     */

  }, {
    key: "queryDepartInfoMap",
    value: function () {
      var _queryDepartInfoMap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(ids) {
        var _this3 = this;

        var queryIdSet, queryIds, currentQuery, params, departments;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                queryIdSet = new Set();
                ids.forEach(function (id) {
                  if (!_this3.departmentMap.has(id)) {
                    queryIdSet.add(id);
                  }
                });

                if (!(queryIdSet.size > 0)) {
                  _context9.next = 13;
                  break;
                }

                queryIds = Array.from(queryIdSet);

              case 4:
                if (!queryIds.length) {
                  _context9.next = 13;
                  break;
                }

                currentQuery = queryIds.splice(0, this.batchQueryDepartLimit);
                params = {
                  func: 1,
                  f: 'json',
                  auth_list: JSON.stringify({
                    info: currentQuery.map(function (id) {
                      return {
                        id: id,
                        type: 2
                      };
                    })
                  })
                };
                _context9.next = 9;
                return this.axios.post('/webdisk/member_info', qsStringify(params)).then(function (res) {
                  var _res$data3, _res$data3$head;

                  if (((_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : (_res$data3$head = _res$data3.head) === null || _res$data3$head === void 0 ? void 0 : _res$data3$head.ret) === 0) return res.data.body.member;
                  return [];
                })["catch"](function (err) {
                  _this3.errLog('queryDepartInfoMap error', err);

                  return [];
                });

              case 9:
                departments = _context9.sent;
                departments.forEach(function (item) {
                  _this3.departmentMap.set("".concat(item.vid), item);
                });
                _context9.next = 4;
                break;

              case 13:
                return _context9.abrupt("return", ids.reduce(function (map, id) {
                  if (_this3.departmentMap.has(id)) {
                    map.set(id, _this3.departmentMap.get(id));
                  }

                  return map;
                }, new Map()));

              case 14:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function queryDepartInfoMap(_x20) {
        return _queryDepartInfoMap.apply(this, arguments);
      }

      return queryDepartInfoMap;
    }()
    /**
     * 为数组填充openid（如果存在则忽略）
     * @param data 数据数组
     * @param idFieldName id所在的字段名
     * @returns
     */

  }, {
    key: "fillOpenid",
    value: function () {
      var _fillOpenid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(data) {
        var _this4 = this;

        var idFieldName,
            ids,
            _args10 = arguments;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                idFieldName = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : 'vid';
                ids = data.filter(function (i) {
                  return !i.openid;
                }).map(function (item) {
                  return item[idFieldName];
                });
                _context10.next = 4;
                return this.queryUserInfoMap(ids);

              case 4:
                data.forEach(function (item) {
                  if (item.openid) return;

                  var user = _this4.map.get(item[idFieldName]);

                  if (user) item.openid = user.openid;else item.openid = '';
                });
                return _context10.abrupt("return", data);

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function fillOpenid(_x21) {
        return _fillOpenid.apply(this, arguments);
      }

      return fillOpenid;
    }()
    /**
     * 获取已登录用户的用户信息
     * @param forceRemote 不从缓存获取
     * @throws {{ code: 12100 | 12105 | 12104 | -20002 | -1; msg: string }} 无登录态会抛出对应错误码，其他情况一概转成`-1`
     */

  }, {
    key: "getUserInfo",
    value: function () {
      var _getUserInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _this5 = this;

        var forceRemote,
            queryByMemberInfo,
            vidInCookie,
            uidInCookie,
            _this$userInfo,
            _this$userInfo2,
            memberInfoTask,
            _args11 = arguments;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                forceRemote = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : false;
                queryByMemberInfo = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : false;
                vidInCookie = getCookie('wedrive_uin') || getCookie('tdoc_vid') || '';
                uidInCookie = getCookie('tdoc_uid');
                this.isOpenIdSessionFlag = !!uidInCookie && !!getCookie('wedoc_openid');

                if (!(!forceRemote && !queryByMemberInfo)) {
                  _context11.next = 10;
                  break;
                }

                if (!(this.isOpenIdSessionFlag && ((_this$userInfo = this.userInfo) === null || _this$userInfo === void 0 ? void 0 : _this$userInfo.uid) === uidInCookie)) {
                  _context11.next = 8;
                  break;
                }

                return _context11.abrupt("return", this.userInfo);

              case 8:
                if (!(vidInCookie && ((_this$userInfo2 = this.userInfo) === null || _this$userInfo2 === void 0 ? void 0 : _this$userInfo2.vid) === vidInCookie)) {
                  _context11.next = 10;
                  break;
                }

                return _context11.abrupt("return", this.userInfo);

              case 10:
                if (!this.userInfoReqPromise) {
                  _context11.next = 14;
                  break;
                }

                _context11.next = 13;
                return this.userInfoReqPromise;

              case 13:
                return _context11.abrupt("return", _context11.sent);

              case 14:
                memberInfoTask = queryByMemberInfo ? this.queryUserInfoInWedrive([{
                  vid: vidInCookie,
                  uid: uidInCookie
                }]) : null;
                this.userInfoReqPromise = Promise.all([this.getLoginUser(), this.getWedriveLoginUser(), memberInfoTask]).then(function (_ref) {
                  var _ref2 = _slicedToArray(_ref, 3),
                      user = _ref2[0],
                      wedriveUser = _ref2[1],
                      selfInfo = _ref2[2];

                  var wxUser = {};

                  if (user.tinyid && wedriveUser.xid && wedriveUser.wedrive_login_type === UserLoginType.kWeChat) {
                    var userInfo = _this5.map.get(wedriveUser.xid);

                    userInfo.uid = userInfo.vid;
                    userInfo.vid = wedriveUser.xid;
                    userInfo.tinyid = user.tinyid;
                    wxUser.vid = userInfo.xid;
                    wxUser.uid = userInfo.uid;
                  }

                  if (Array.isArray(selfInfo) && selfInfo.length === 1) {
                    var preUserInfo = selfInfo[0];
                    var _preUserInfo$extern_n = preUserInfo.extern_name,
                        extern_name = _preUserInfo$extern_n === void 0 ? '' : _preUserInfo$extern_n,
                        _preUserInfo$unify_na = preUserInfo.unify_name,
                        unify_name = _preUserInfo$unify_na === void 0 ? '' : _preUserInfo$unify_na,
                        _preUserInfo$short_na = preUserInfo.short_name,
                        short_name = _preUserInfo$short_na === void 0 ? '' : _preUserInfo$short_na;
                    user.extern_name = extern_name;
                    user.unify_name = unify_name;
                    user.short_name = short_name;
                  }

                  var loginUserInfo = Object.assign({}, user, wedriveUser, wxUser); // `prototype.userInfo`为当前登录用户的信息，结构为user_info接口的结构
                  // `userInfo.uid`跟随openid登录态定，如果是非openid登录态则是`vid`
                  // 也就是最终以user_info接口返回的为准

                  loginUserInfo.uid = user.uid;
                  _this5.userInfo = loginUserInfo;
                  _this5.displayNamePriorityType = wedriveUser.name_priority || DisplayNamePriorityType.UserAlias;
                  _this5.userInfoReqPromise = undefined;
                  return _this5.userInfo;
                })["catch"](function (e) {
                  _this5.userInfoReqPromise = undefined;
                  throw e;
                });
                _context11.next = 18;
                return this.userInfoReqPromise;

              case 18:
                return _context11.abrupt("return", _context11.sent);

              case 19:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getUserInfo() {
        return _getUserInfo.apply(this, arguments);
      }

      return getUserInfo;
    }()
    /**
     * 获取用户信息，可能会不存在，需要提前调用queryUserInfo加载到缓存里
     * @returns <WedriveUserInfo | undefined>
     */

  }, {
    key: "get",
    value: function get(id) {
      var queryId = "".concat(id).replace(ID_PREFIX_REGEX, '');
      return this.map.get(queryId);
    }
    /**
     * 获取部门信息，可能会不存在，需要提前调用queryDepartInfo加载到缓存里
     * @returns <WedriveDepartInfo | undefined>
     */

  }, {
    key: "getDepart",
    value: function getDepart(id) {
      return this.departmentMap.get(id);
    }
    /**
     * 同步获取vid
     * 注意：如果获取时机太早可能会失败，业务需要自己做好容错
     *      或者先`await this.getUserInfo()`
     * @returns string vid
     */

  }, {
    key: "getVid",
    value: function getVid() {
      var _this$userInfo3, _this$userInfo4;

      if ((_this$userInfo3 = this.userInfo) !== null && _this$userInfo3 !== void 0 && _this$userInfo3.vid) return this.userInfo.vid;
      if ((_this$userInfo4 = this.userInfo) !== null && _this$userInfo4 !== void 0 && _this$userInfo4.xid) return this.userInfo.xid;
      return getCookie('wedrive_uin') || getCookie('tdoc_vid') || '';
    }
    /**
     * 同步获取 corpId
     * @returns string corpId
     */

  }, {
    key: "getCorpId",
    value: function getCorpId() {
      var _this$userInfo5;

      return ((_this$userInfo5 = this.userInfo) === null || _this$userInfo5 === void 0 ? void 0 : _this$userInfo5.corp_id) || getCookie('xm_disk_corp_id') || '';
    }
    /**
     * 同步获取uid
     * @returns 是否有登录态
     */

  }, {
    key: "hasSidCookie",
    value: function hasSidCookie() {
      return getCookie('wedrive_sid') && getCookie('wedrive_skey') || getCookie('wedoc_sid') && getCookie('wedoc_skey');
    }
    /**
     * 获取显示名称（姓名与别名，无企业名、备注）
     */

  }, {
    key: "getDisplayName",
    value: function getDisplayName(user, fallbackName) {
      return this.getDefaultDisplayName(_objectSpread(_objectSpread({}, user), {}, {
        corp_id: user.corp_id !== WECHAT_CORP_ID ? user.corp_id : '',
        corp_name: '',
        remark: ''
      }), fallbackName);
    }
    /**
     * 获取自己的对外展示名称
     * TODO(ivan) 目前是一定会调用 CGI 获取的，后续可以考虑缓存
     */

  }, {
    key: "getSelfExternalName",
    value: function () {
      var _getSelfExternalName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var userInfo;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.getUserInfo(false, true);

              case 2:
                userInfo = _context12.sent;
                return _context12.abrupt("return", userInfo === null || userInfo === void 0 ? void 0 : userInfo.extern_name);

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getSelfExternalName() {
        return _getSelfExternalName.apply(this, arguments);
      }

      return getSelfExternalName;
    }()
    /**
     * 获取默认显示名称
     * @see https://doc.weixin.qq.com/sheet/e3_AHEAfgZ2ACcpH0C4ETVQuKQM9p9Fb?scode=AJEAIQdfAAo1188DfCAHEAfgZ2ACc&tab=p9o0co
     */

  }, {
    key: "getDefaultDisplayName",
    value: function getDefaultDisplayName(user, fallbackName) {
      var _this$userInfo6;

      // 查询失败硬编码名称: unknown; 后端硬编码名称: 微信用户
      // 这两种优先用外部传入的兜底人名
      var name = user.name === 'unknown' || user.name === '微信用户' ? fallbackName || user.name : user.name;

      if ("".concat(user.corp_id) === "".concat((_this$userInfo6 = this.userInfo) === null || _this$userInfo6 === void 0 ? void 0 : _this$userInfo6.corp_id)) {
        if (user.remark) {
          return user.remark;
        }

        var preferAlias = this.displayNamePriorityType === DisplayNamePriorityType.UserAlias;
        var firstName = preferAlias ? user.english_name : name;
        var lastName = preferAlias ? name : user.english_name;
        return firstName && lastName ? "".concat(firstName, "(").concat(lastName, ")") : "".concat(firstName || lastName);
      }

      var corpName = user.corp_name || ("".concat(user.corp_id) === WECHAT_CORP_ID ? $t('微信') : '');
      var userName = user.remark || name;
      return corpName ? "".concat(userName, "@").concat(corpName) : userName;
    }
    /**
     * 获取默认显示名称（不带企业）
     */

  }, {
    key: "getDisplayNameWithoutCorp",
    value: function getDisplayNameWithoutCorp(user, fallbackName) {
      return this.getDefaultDisplayName(_objectSpread(_objectSpread({}, user), {}, {
        corp_id: user.corp_id !== WECHAT_CORP_ID ? user.corp_id : '',
        corp_name: ''
      }), fallbackName);
    }
    /**
     * 获取无备注的显示名称
     * @see https://doc.weixin.qq.com/sheet/e3_AHEAfgZ2ACcpH0C4ETVQuKQM9p9Fb?scode=AJEAIQdfAAo1188DfCAHEAfgZ2ACc&tab=6rcnx0
     */

  }, {
    key: "getDisplayNameWithoutRemark",
    value: function getDisplayNameWithoutRemark(user, fallbackName) {
      return this.getDefaultDisplayName(_objectSpread(_objectSpread({}, user), {}, {
        remark: ''
      }), fallbackName);
    }
    /**
     * 获取短名称
     * @see https://doc.weixin.qq.com/sheet/e3_AHEAfgZ2ACcpH0C4ETVQuKQM9p9Fb?scode=AJEAIQdfAAo1188DfCAHEAfgZ2ACc&tab=hs9fi0
     */

  }, {
    key: "getShortDisplayName",
    value: function getShortDisplayName(user, fallbackName) {
      var _this$userInfo7;

      var hasBothName = user.name && user.english_name;
      var preferAlias = this.displayNamePriorityType === DisplayNamePriorityType.UserAlias;
      var name = hasBothName && preferAlias ? '' : user.name;
      var english_name = hasBothName && !preferAlias ? '' : user.english_name;
      var isSameCorp = "".concat(user.corp_id) === "".concat((_this$userInfo7 = this.userInfo) === null || _this$userInfo7 === void 0 ? void 0 : _this$userInfo7.corp_id);
      var remark = isSameCorp ? '' : user.remark;
      return this.getDefaultDisplayName(_objectSpread(_objectSpread({}, user), {}, {
        remark: remark,
        name: name,
        english_name: english_name
      }), fallbackName);
    }
    /**
       * @param id vid >> 48 = 6
       * @returns boolean
       */

  }, {
    key: "isVid",
    value: function isVid$1(id) {
      return isVid(id);
    }
    /**
     * @param id vid >> 48 = 20
     * @returns boolean
     */

  }, {
    key: "isAppId",
    value: function isAppId$1(id) {
      return isAppId(id);
    }
    /**
       * @param id uid >> 32 = 3050710(2e8cd6)
       * @returns boolean
       */

  }, {
    key: "isWedriveUid",
    value: function isWedriveUid$1(id) {
      return isWedriveUid(id);
    }
  }, {
    key: "isWedriveUin",
    value: function isWedriveUin$1(id) {
      return isWedriveUin(id);
    }
    /**
       * @param id xid >> 48 = 28
       */

  }, {
    key: "isXid",
    value: function isXid$1(id) {
      return isXid(id);
    }
  }, {
    key: "isWxTinyid",
    value: function isWxTinyid$1(id) {
      return isWxTinyid(id);
    }
  }, {
    key: "isOpenId",
    value: function isOpenId$1(id) {
      return isOpenId(id);
    }
  }, {
    key: "isOpenIdSession",
    get: function get() {
      return this.isOpenIdSessionFlag;
    }
    /**
     * 从企微 jsapi 获取用户备注名
     */

  }, {
    key: "fillUserRemark",
    value: function () {
      var _fillUserRemark = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(users) {
        var _this6 = this,
            _window$tdocs;

        var vidList;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                users = users.map(function (user) {
                  var _this6$map$get, _this6$remarkMap$get, _this6$map$get2, _this6$remarkMap$get2;

                  return _objectSpread(_objectSpread({}, user), {}, {
                    remark: ((_this6$map$get = _this6.map.get(user.vid)) === null || _this6$map$get === void 0 ? void 0 : _this6$map$get.remark) || ((_this6$remarkMap$get = _this6.remarkMap.get(user.vid)) === null || _this6$remarkMap$get === void 0 ? void 0 : _this6$remarkMap$get.remark),
                    corp_name: ((_this6$map$get2 = _this6.map.get(user.vid)) === null || _this6$map$get2 === void 0 ? void 0 : _this6$map$get2.corp_name) || ((_this6$remarkMap$get2 = _this6.remarkMap.get(user.vid)) === null || _this6$remarkMap$get2 === void 0 ? void 0 : _this6$remarkMap$get2.corpName) || user.corp_name
                  });
                });
                vidList = users.map(function (user) {
                  return user.vid;
                }).filter(function (id) {
                  return !!id && !(_this6.map.get(id) || _this6.remarkMap.has(id));
                });

                if (!(!vidList.length || !((_window$tdocs = window.tdocs) !== null && _window$tdocs !== void 0 && _window$tdocs.getUserInfo))) {
                  _context13.next = 4;
                  break;
                }

                return _context13.abrupt("return", users);

              case 4:
                return _context13.abrupt("return", new Promise(function (resolve) {
                  // 超时就不获取备注了
                  var timer = setTimeout(function () {
                    resolve(users);
                  }, 3000 + vidList.length * 10);
                  window.tdocs.getUserInfo({
                    vidList: vidList,
                    docId: _this6.currentDocId || getPadId()
                  }).then(function (res) {
                    var persons = res.persons || [];
                    var personInfoMap = persons.reduce( // 企微权限已经判断好了，用来更新corpName
                    function (map, user) {
                      return _objectSpread(_objectSpread({}, map), {}, _defineProperty({}, user.vid, {
                        remark: user.remark,
                        corp_name: user.corpName
                      }));
                    }, {});
                    clearTimeout(timer);
                    resolve(users.map(function (user) {
                      var _personInfoMap$user$v, _this6$map$get3, _this6$remarkMap$get3, _personInfoMap$user$v2, _this6$map$get4;

                      var remark = ((_personInfoMap$user$v = personInfoMap[user.vid]) === null || _personInfoMap$user$v === void 0 ? void 0 : _personInfoMap$user$v.remark) || ((_this6$map$get3 = _this6.map.get(user.vid)) === null || _this6$map$get3 === void 0 ? void 0 : _this6$map$get3.remark) || ((_this6$remarkMap$get3 = _this6.remarkMap.get(user.vid)) === null || _this6$remarkMap$get3 === void 0 ? void 0 : _this6$remarkMap$get3.remark) || '';
                      var corpName = ((_personInfoMap$user$v2 = personInfoMap[user.vid]) === null || _personInfoMap$user$v2 === void 0 ? void 0 : _personInfoMap$user$v2.corp_name) || ((_this6$map$get4 = _this6.map.get(user.vid)) === null || _this6$map$get4 === void 0 ? void 0 : _this6$map$get4.corp_name) || '';
                      !_this6.remarkMap.has(user.vid) && _this6.remarkMap.set(user.vid, {
                        remark: remark,
                        corpName: corpName
                      });
                      return _objectSpread(_objectSpread({}, user), {}, {
                        remark: remark
                      }, corpName ? {
                        corp_name: corpName
                      } : {});
                    }));
                  })["catch"](function (err) {
                    _this6.errLog('getUserInfo jsapi error', err);

                    clearTimeout(timer);
                    resolve(users);
                  });
                }));

              case 5:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function fillUserRemark(_x22) {
        return _fillUserRemark.apply(this, arguments);
      }

      return fillUserRemark;
    }()
    /**
       *
       * @param ids 微信用户的 tinyid
       * @returns
       */

  }, {
    key: "queryUserInfoByTinyid",
    value: function () {
      var _queryUserInfoByTinyid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(ids, _extraQueryMap, scene) {
        var _this7 = this;

        var tinyids, extraQueryMap, result, _res$data4, _res$data5, _res$data5$result, currentQuery, res;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                tinyids = ids.filter(function (id) {
                  return _this7.isWxTinyid(id);
                });
                extraQueryMap = _extraQueryMap ? _objectSpread({}, _extraQueryMap) : {};

                if (!(tinyids.length === 0)) {
                  _context15.next = 4;
                  break;
                }

                return _context15.abrupt("return", []);

              case 4:
                result = [];

              case 5:
                if (!tinyids.length) {
                  _context15.next = 14;
                  break;
                }

                currentQuery = tinyids.splice(0, this.benchQueryLimit);
                _context15.next = 9;
                return this.axios.post('/sdc/getusermarkname', qsStringify({
                  uids: "[".concat(currentQuery.join(','), "]"),
                  localPadId: this.currentDocId || getPadId(),
                  xsrf: getXsrf()
                }));

              case 9:
                res = _context15.sent;

                if (!(((_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.retcode) === 0 && (_res$data5 = res.data) !== null && _res$data5 !== void 0 && (_res$data5$result = _res$data5.result) !== null && _res$data5$result !== void 0 && _res$data5$result.rsp)) {
                  _context15.next = 12;
                  break;
                }

                return _context15.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
                  var rsp, wxUsers, resUids, notExists, uids, uid2xidMap, _uin2xidRes$data, _uin2xidRes$data$body, uin2xidRes, _resUids, _notExists, xids, xidInfoMap, infos;

                  return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                      switch (_context14.prev = _context14.next) {
                        case 0:
                          rsp = res.data.result.rsp;
                          wxUsers = rsp.filter(function (i) {
                            // 入参是以tinyid为key的，这里要把映射的id都加上
                            if (i.wedriveUin && extraQueryMap[i.reqUid]) {
                              extraQueryMap[i.wedriveUin] = extraQueryMap[i.reqUid];
                            }

                            if (i.wedriveUin && _this7.map.has(i.wedriveUin)) {
                              var user = _this7.map.get(i.wedriveUin);

                              user.tinyid = i.reqUid;

                              _this7.map.set(user.tinyid, user);

                              return false;
                            }

                            return true;
                          }); // 统计没有查到的用户

                          resUids = new Set(rsp.filter(function (i) {
                            return i.wedriveUin;
                          }).map(function (i) {
                            return "".concat(i.reqUid);
                          }));
                          notExists = currentQuery.filter(function (id) {
                            return !resUids.has(id);
                          });

                          if (notExists.length) {
                            _this7.errLog('queryUserInfoByTinyid error, /sdc/getusermarkname empty for uid:', notExists.join(','));
                          }

                          uids = wxUsers.map(function (item) {
                            return "".concat(item.wedriveUin || '');
                          }).filter(function (i) {
                            return !!i;
                          });
                          uid2xidMap = new Map();

                          if (!(uids.length > 0)) {
                            _context14.next = 12;
                            break;
                          }

                          _context14.next = 10;
                          return _this7.axios.post('/wedoc/doc_member_mgr', qsStringify({
                            func: 8,
                            docid: _this7.currentDocId || getPadId(),
                            scode: getURLQuery('scode'),
                            wx_uin: uids
                          }));

                        case 10:
                          uin2xidRes = _context14.sent;

                          if (Array.isArray((_uin2xidRes$data = uin2xidRes.data) === null || _uin2xidRes$data === void 0 ? void 0 : (_uin2xidRes$data$body = _uin2xidRes$data.body) === null || _uin2xidRes$data$body === void 0 ? void 0 : _uin2xidRes$data$body.uin2xid)) {
                            uin2xidRes.data.body.uin2xid.forEach(function (item) {
                              uid2xidMap.set("".concat(item.uin), "".concat(item.xid));

                              if (extraQueryMap[item.uin]) {
                                extraQueryMap[item.xid] = extraQueryMap[item.uin];
                              }
                            }); // 统计没有查到的用户

                            _resUids = new Set(uin2xidRes.data.body.uin2xid.map(function (i) {
                              return "".concat(i.uin);
                            }));
                            _notExists = uids.filter(function (id) {
                              return !_resUids.has(id);
                            });

                            if (_notExists.length) {
                              _this7.errLog('queryUserInfoByTinyid error, /wedoc/doc_member_mgr empty for uid:', _notExists.join(','));
                            }
                          } else {
                            _this7.errLog('queryUserInfoByTinyid error, /wedoc/doc_member_mgr empty for uid:', uids.join(','));
                          }

                        case 12:
                          // 补上 xid 的 openid 等信息
                          xids = uids.map(function (uid) {
                            return uid2xidMap.get(uid);
                          }).filter(function (i) {
                            return !!i && !_this7.map.get(i);
                          });
                          xidInfoMap = new Map();

                          if (!xids.length) {
                            _context14.next = 19;
                            break;
                          }

                          _context14.next = 17;
                          return _this7.queryUserInfoInWedrive(xids.map(function (id) {
                            var _extraQueryMap$id;

                            return {
                              xid: id,
                              is_external_member: extraQueryMap === null || extraQueryMap === void 0 ? void 0 : (_extraQueryMap$id = extraQueryMap[id]) === null || _extraQueryMap$id === void 0 ? void 0 : _extraQueryMap$id.isExternalMember
                            };
                          }), scene);

                        case 17:
                          infos = _context14.sent;
                          infos.forEach(function (info) {
                            return info.xid && xidInfoMap.set(info.xid, info);
                          });

                        case 19:
                          wxUsers.forEach(function (user) {
                            var _user$userPic, _user$englishName, _user$markName;

                            var wxUin = "".concat(user.reqUid || user.uid || '');
                            var wedriveUser = {
                              avatar: (_user$userPic = user.userPic) !== null && _user$userPic !== void 0 ? _user$userPic : '',
                              english_name: (_user$englishName = user.englishName) !== null && _user$englishName !== void 0 ? _user$englishName : '',
                              name: (_user$markName = user.markName) !== null && _user$markName !== void 0 ? _user$markName : '',
                              type: 1,
                              user_type: 3,
                              corp_name: user.corpName || '微信',
                              position: '',
                              corp_id: WECHAT_CORP_ID,
                              vid: wxUin,
                              uid: wxUin,
                              openid: '',
                              tinyid: wxUin
                            };

                            if (user.wedriveUin) {
                              if (uid2xidMap.has("".concat(user.wedriveUin))) {
                                wedriveUser.xid = uid2xidMap.get(user.wedriveUin);
                              }

                              wedriveUser.uid = user.wedriveUin;
                              wedriveUser.vid = wedriveUser.xid || user.wedriveUin;
                              wedriveUser.openid = '';

                              if (wedriveUser.xid && xidInfoMap.has(wedriveUser.xid)) {
                                var _xidInfoMap$get;

                                wedriveUser.openid = ((_xidInfoMap$get = xidInfoMap.get(wedriveUser.xid)) === null || _xidInfoMap$get === void 0 ? void 0 : _xidInfoMap$get.openid) || '';
                              }
                            }

                            result.push(wedriveUser);
                          });

                        case 20:
                        case "end":
                          return _context14.stop();
                      }
                    }
                  }, _callee14);
                })(), "t0", 12);

              case 12:
                _context15.next = 5;
                break;

              case 14:
                return _context15.abrupt("return", result);

              case 15:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function queryUserInfoByTinyid(_x23, _x24, _x25) {
        return _queryUserInfoByTinyid.apply(this, arguments);
      }

      return queryUserInfoByTinyid;
    }()
  }, {
    key: "queryUserInfoInWedrive",
    value: function () {
      var _queryUserInfoInWedrive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(ids, scene, sceneId) {
        var _this8 = this;

        var result, currentQuery, postData, resultIds, notExists;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                result = [];

              case 1:
                if (!ids.length) {
                  _context16.next = 10;
                  break;
                }

                currentQuery = ids.splice(0, this.benchQueryLimit);
                postData = {
                  func: 3,
                  docid: this.currentDocId || getPadId(),
                  f: 'json',
                  id_list: currentQuery.map(function (i) {
                    return JSON.stringify(i);
                  })
                };

                if (scene) {
                  postData.scene = scene;
                }

                if (sceneId) {
                  postData.scene_id = sceneId;
                }

                _context16.next = 8;
                return this.axios.post('/webdisk/member_info', qsStringify(postData)).then(function (_ref3) {
                  var _data$head;

                  var data = _ref3.data;

                  if ((data === null || data === void 0 ? void 0 : (_data$head = data.head) === null || _data$head === void 0 ? void 0 : _data$head.ret) === 0) {
                    var _data$body$member;

                    (_data$body$member = data.body.member) === null || _data$body$member === void 0 ? void 0 : _data$body$member.forEach(function (member) {
                      var corpId = "".concat(member.corp_id || '');
                      var uid = "".concat(member.uid) === '0' ? '' : "".concat(member.uid || '');
                      var vid = "".concat(member.vid || '');
                      var isSameCorp = _this8.userInfo && corpId === _this8.userInfo.corp_id;
                      var externName = "".concat(member.extern_name || '');
                      var unifyName = "".concat(member.unify_name || '');
                      var shortName = "".concat(member.short_name || '');

                      var exists = _this8.map.get(vid) || _this8.map.get(uid);

                      if (exists) {
                        // 可以存在一种情况：
                        // 模块A用vid查，模块B用uid查，那么可能会重复查询
                        if (!member.xid) {
                          if (!exists.vid) exists.vid = "".concat(vid);
                          if (!exists.uid) exists.uid = "".concat(uid);
                        } // 如果存在 extern_name unify_name short_name 直接更新到 Map 引用的对应对象中


                        // 如果存在 extern_name unify_name short_name 直接更新到 Map 引用的对应对象中
                        externName && (exists.extern_name = externName);
                        unifyName && (exists.unify_name = unifyName);
                        shortName && (exists.short_name = shortName);
                        result.push(exists);
                      } else if (member.xid) {
                        var xid = "".concat(member.xid || '');

                        var user = _objectSpread(_objectSpread({}, member), {}, {
                          xid: xid,
                          vid: xid,
                          uid: "".concat(member.drive_uin || ''),
                          openid: member.openid || '',
                          corp_id: corpId
                        });

                        result.push(user);
                      } else if (member.drive_uin) {
                        var _user = _objectSpread(_objectSpread({}, member), {}, {
                          uid: "".concat(member.drive_uin || ''),
                          openid: member.openid,
                          corp_id: corpId
                        });

                        result.push(_user);
                      } else {
                        var _user2 = _objectSpread(_objectSpread({}, member), {}, {
                          english_name: isSameCorp ? member.english_name : '',
                          vid: vid,
                          uid: uid,
                          corp_id: corpId
                        });

                        result.push(_user2);
                      }
                    });
                  }
                });

              case 8:
                _context16.next = 1;
                break;

              case 10:
                resultIds = new Set();
                result.forEach(function (i) {
                  if (i.uid) resultIds.add(i.uid);
                  if (i.vid) resultIds.add(i.vid);
                  if (i.xid) resultIds.add(i.xid);
                  if (i.openid) resultIds.add(i.openid);
                }); // 统计没有查到的用户

                notExists = ids.filter(function (i) {
                  if (i.uid) return !resultIds.has(i.uid);
                  if (i.vid) return !resultIds.has(i.vid);
                  if (i.xid) return !resultIds.has(i.xid);
                  if (i.openid) return !resultIds.has(i.openid);
                  return true;
                });

                if (notExists.length) {
                  this.errLog('queryUserInfoInWedrive error, /webdisk/member_info empty for id:', notExists.map(function (i) {
                    return JSON.stringify(i);
                  }).join(','));
                }

                return _context16.abrupt("return", result);

              case 15:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function queryUserInfoInWedrive(_x26, _x27, _x28) {
        return _queryUserInfoInWedrive.apply(this, arguments);
      }

      return queryUserInfoInWedrive;
    }()
  }, {
    key: "getLoginUser",
    value: function () {
      var _getLoginUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var _this9 = this;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.abrupt("return", this.axios.post("/cgi-bin/online_docs/user_info?xsrf=".concat(getXsrf())).then(function (res) {
                  var data = res.data;
                  var retcode = data.retcode;

                  if (retcode === 0) {
                    return data;
                  } // TODO(stee): retcode === 12106 retry


                  // TODO(stee): retcode === 12106 retry
                  if (retcode === 12101 || retcode === 12104 || retcode === 12105) {
                    throw {
                      code: retcode,
                      msg: data.msg,
                      type: 'user_info'
                    };
                  }

                  throw {
                    code: retcode,
                    msg: "unknown code: ".concat(retcode),
                    type: 'user_info'
                  };
                })["catch"](function (e) {
                  _this9.errLog('getLoginUser error', e);

                  throw {
                    code: -1,
                    msg: 'unknown error',
                    type: 'user_info',
                    error: e
                  };
                }));

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function getLoginUser() {
        return _getLoginUser.apply(this, arguments);
      }

      return getLoginUser;
    }()
  }, {
    key: "getWedriveLoginUser",
    value: function () {
      var _getWedriveLoginUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var _this10 = this;

        var userInfo;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return Promise.race([this.getWedriveLoginUserByJSAPI(), sleep(200)]);

              case 2:
                userInfo = _context18.sent;

                if (!(userInfo !== null && userInfo !== void 0 && userInfo.vid)) {
                  _context18.next = 5;
                  break;
                }

                return _context18.abrupt("return", userInfo);

              case 5:
                return _context18.abrupt("return", this.axios.get('/doc/info?func=4').then(function (res) {
                  var _res$data6, _res$data6$head;

                  var code = (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : (_res$data6$head = _res$data6.head) === null || _res$data6$head === void 0 ? void 0 : _res$data6$head.ret;

                  if (code === 0) {
                    if (!res.data.body) {
                      throw {
                        code: -2,
                        msg: 'body is empty',
                        type: 'doc/info'
                      };
                    }

                    var _res$data$body = res.data.body,
                        account = _res$data$body.account,
                        name_priority = _res$data$body.name_priority,
                        login_type = _res$data$body.login_type;
                    var uid = "".concat(account.s_uid || account.uid);

                    var _vid = "".concat(account.s_vid || account.vid);

                    var user = {
                      avatar: account.avatar,
                      corp_name: account.corp_name,
                      english_name: account.english_name || account.nick_name !== account.name && account.nick_name || '',
                      name: account.name,
                      position: '',
                      type: 1,
                      user_type: account.corp_name === '微信' ? 3 : 1,
                      uid: uid,
                      vid: _vid,
                      openid: account.openid,
                      corp_id: "".concat(account.corp_id || ''),
                      xid: "".concat(account.xid || '')
                    };
                    if (_vid) _this10.map.set(_vid, user);
                    if (uid) _this10.map.set(uid, user);
                    if (user.openid) _this10.map.set(user.openid, user);
                    if (user.xid) _this10.map.set(user.xid, user);
                    return _objectSpread(_objectSpread({}, user), {}, {
                      vid: _vid,
                      xid: user.xid,
                      openid: user.openid,
                      corp_name: user.corp_name,
                      name_priority: name_priority,
                      wedrive_login_type: login_type
                    });
                  }

                  if (code === -20002) {
                    var _res$data7, _res$data7$head;

                    throw {
                      code: code,
                      msg: (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : (_res$data7$head = _res$data7.head) === null || _res$data7$head === void 0 ? void 0 : _res$data7$head.msg,
                      type: 'doc/info'
                    };
                  }

                  throw {
                    code: code,
                    msg: "unknown code: ".concat(code),
                    type: 'doc/info'
                  };
                })["catch"](function (e) {
                  _this10.errLog('getLoginUser error', e);

                  throw {
                    code: -1,
                    msg: 'unknown error',
                    type: 'doc/info',
                    error: e
                  };
                }));

              case 6:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function getWedriveLoginUser() {
        return _getWedriveLoginUser.apply(this, arguments);
      }

      return getWedriveLoginUser;
    }()
  }, {
    key: "getWedriveLoginUserByJSAPI",
    value: function () {
      var _getWedriveLoginUserByJSAPI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var _tdocs;

        var uid, openId, isOpenIdCorp, tdocs, _globalThis$tdocs, _top, weworkInfo, user;

        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                uid = getCookie('uid') || getCookie('tdoc_uid');
                openId = getCookie('wedoc_openid');
                /**
                 * openid 企业不走后台接口：
                 * 1. openid,uid 从 cookie 里取
                 * 2. vid 从 jsapi 里取
                 * vid 企业还是要走接口：
                 * 1. cgi openid 会返回，cookie 里取不到
                 * 2. cgi uid/s_uid 会返回 131 开头的 uid，cookie 里取不到
                 */

                isOpenIdCorp = !!openId;

                try {
                  // swbox 本身没有引入 tdocs, 使用父级页面的 tdocs
                  tdocs = (_globalThis$tdocs = _globalThis.tdocs) !== null && _globalThis$tdocs !== void 0 ? _globalThis$tdocs : (_top = top) === null || _top === void 0 ? void 0 : _top.tdocs;
                } catch (e) {
                  this.errLog('get tdocs error', e);
                }

                if (!(ua.isWxWork && typeof ((_tdocs = tdocs) === null || _tdocs === void 0 ? void 0 : _tdocs.getWeworkInfo) === 'function' && uid && isOpenIdCorp)) {
                  _context19.next = 19;
                  break;
                }

                _context19.prev = 5;
                _context19.next = 8;
                return tdocs.getWeworkInfo();

              case 8:
                weworkInfo = _context19.sent;
                user = {
                  avatar: weworkInfo.avatar,
                  corp_name: weworkInfo.corpName,
                  english_name: weworkInfo.englishName || weworkInfo.nickName !== weworkInfo.name && weworkInfo.nickName || '',
                  name: weworkInfo.name,
                  position: '',
                  type: 1,
                  user_type: 1,
                  // 企微端内不可能是微信登录态
                  uid: uid,
                  vid: weworkInfo.vid,
                  openid: openId,
                  corp_id: weworkInfo.corpId || '',
                  xid: '' // 企微端内不可能是微信登录态

                };
                if (user.vid) this.map.set(user.vid, user);
                if (user.uid) this.map.set(user.uid, user);
                if (user.openid) this.map.set(user.openid, user);
                return _context19.abrupt("return", _objectSpread(_objectSpread({}, user), {}, {
                  name_priority: weworkInfo.namePriority,
                  wedrive_login_type: UserLoginType.kWeWork
                }));

              case 16:
                _context19.prev = 16;
                _context19.t0 = _context19["catch"](5);
                this.errLog('getWedriveLoginUser from jsapi error', _context19.t0);

              case 19:
                return _context19.abrupt("return", null);

              case 20:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[5, 16]]);
      }));

      function getWedriveLoginUserByJSAPI() {
        return _getWedriveLoginUserByJSAPI.apply(this, arguments);
      }

      return getWedriveLoginUserByJSAPI;
    }()
  }, {
    key: "getGuestUserInfo",
    value: function getGuestUserInfo() {
      var guestUserInfo = {
        app_flag: 0,
        avatar: '',
        cgicode: 0,
        client_ip: '',
        corp_id: '0',
        corp_name: 'Guest',
        create_doc_time: 0,
        credit_level: 0,
        credit_msg: '',
        credit_time: 0,
        domain: '',
        domain_id: '0',
        edit_doc_time: 0,
        email: '',
        english_name: '',
        expired: 0,
        is_grayed: true,
        login: true,
        login_time: 0,
        login_type: 3,
        msg: 'success',
        nick: 'Guest',
        phone: '',
        qq_avatar: '',
        qq_nick: '',
        ret: 0,
        retcode: 0,
        third_appid: '',
        third_source: 0,
        third_uid: '',
        tinyid: '0',
        toid: '0',
        uid: '0',
        vid: '0',
        openid: '',
        uid_source: 3,
        uin: 0,
        upgrade_status: 0,
        work_id: '',
        wx_avatar: '',
        wx_nick: '',
        wx_openid: '',
        wy_bind_uid: null
      };
      this.userInfoReqPromise = undefined;
      this.userInfo = guestUserInfo;
    }
  }, {
    key: "errLog",
    value: function errLog() {
      var _globalThis$log;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      // @ts-ignore
      (_globalThis$log = _globalThis.log) === null || _globalThis$log === void 0 ? void 0 : _globalThis$log.error.apply(_globalThis$log, ['[@tencent/wdocs-user-center]'].concat(args));
    }
  }, {
    key: "setBuildInInfos",
    value: function setBuildInInfos() {
      // 智能表自动化账号
      this.map.set('4294967305', {
        name: $t('自动化流程'),
        english_name: '',
        avatar: 'https://rescdn.qqmail.com/node/webdoc/images/automation_outline_light_24.png',
        position: '',
        type: 1,
        user_type: 4,
        corp_name: '',
        corp_id: '',
        uid: '4294967305',
        vid: '4294967305',
        openid: ''
      });
    }
  }]);

  return WdocsUserCenter;
}();

if (!_globalThis.wdocsUserCenter) {
  _globalThis.wdocsUserCenter = new WdocsUserCenter();
}

var wdocsUserCenter = _globalThis.wdocsUserCenter;

export { wdocsUserCenter };
